import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: require('@//assets/img/sidebar-1.jpg'),
    drawer: null,
    jwtToken: '',
    user: {},
    orderStateItems: [{ label: 'Revisión', value: 'check' }, { label: 'Activa', value: 'active' }, { label: 'Procesando', value: 'process' }, { label: 'Despachada', value: 'deliver' }, { label: 'Cancelada', value: 'cancel' }],
    quotationStateItems: ['Activa', 'Procesando', 'Lista', 'Cancelada'],
    identificationTypes: [{ code: '01', name: 'Cédula Física' }, { code: '02', name: 'Cédula Jurídica' }],
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_SCRIM (state, payload) {
      state.barColor = payload
    },
    LOGIN (state, payload) {
      state.jwtToken = payload.jwtToken
      state.user = payload.user
    },
    LOGOUT (state, payload) {
      state.user = null
      state.jwtToken = ''
    },
  },
  actions: {

  },
  getters: {
    isLoggedIn: state => !!state.jwtToken,
    // authStatus: state => state.status,
  },
})
